export const apiCreate = (): string => '/financial/categories/'
export const apiList = (id?: string): string =>
  !id ? '/financial/categories/' : `/financial/categories/view/${id}`
export const apiUpdate = (id: string): string =>
  `/financial/categories/update/${id}`
export const apiDelete = (id: string): string => `/financial/categories/${id}`
